import { useContext } from "react";
import { Grid2 as Grid, Typography, Stack } from "@mui/material";
import { AppContext } from "../App";
import { TextButton } from "../components/TextButton";

const CERTIFICATIONS = [
  { label: "SSP", value: "ssp" },
  { label: "ILS", value: "focus" },
  { label: "RRP", value: "rrp" },
];

export function ProviderCertifications() {
  const { form, updateForm } = useContext(AppContext);

  const handleSubmit = (value: string) => {
    updateForm({ providerCertifications: value });
  };

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h6" gutterBottom>
        My provider should be certified in the following:
      </Typography>
      <Grid container spacing={1} columns={{ xs: 1, sm: 2, lg: 4 }} alignItems="center" justifyContent="center">
        {CERTIFICATIONS.map(({ label, value }) => (
          <Grid key={value}>
            <TextButton
              selected={form.providerCertifications === value}
              onClick={() => handleSubmit(value)}
              label={label}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
